<template>
  <el-drawer 
    :title="title" 
    :visible.sync="userFormvisible" 
    @open="open" @close="close" 
    :close-on-click-modal="false" 
    direction="rtl"
    :size="drawerWidth">
    <div class="m-20">
      <el-tabs v-model="activeTab">
        <el-tab-pane label="Information" name="info">
          <el-form :model="form" label-position="top" ref="userForm" :rules="rules">
            <el-row :gutter="20">
              <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                <el-form-item :label="$t('user.firstName')" prop="firstName" :label-width="formLabelWidth">
                  <el-input v-model="form.firstName" autocomplete="off"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                <el-form-item :label="$t('user.lastName')" prop="lastName" :label-width="formLabelWidth">
                  <el-input v-model="form.lastName" autocomplete="off"></el-input>
                </el-form-item>
            </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                <el-form-item :label="$t('user.email')" prop="email" :label-width="formLabelWidth">
                  <el-input v-model="form.email" autocomplete="off"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                <el-form-item :label="$t('user.phone')" prop="phone" :label-width="formLabelWidth">
                  <el-input v-model="form.phone" autocomplete="off"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            
            <el-row :gutter="20">
              <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                <el-form-item :label="$t('user.password')" prop="password" :label-width="formLabelWidth">
                  <el-input v-model="form.password"   :show-password="true"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                <el-form-item :label="$t('user.confirmPassword')" prop="confirm" :label-width="formLabelWidth">
                  <el-input  v-model="form.confirm" show-password></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            
            <el-checkbox v-model="form.active" :label="$t('user.activeInd')" border size="small" :disabled="!isAdmin"></el-checkbox>
            <el-checkbox v-model="form.webAccess" :label="$t('user.webAccess')" border size="small" :disabled="!isAdmin"></el-checkbox>
            
            <el-divider content-position="left">{{$t('user.rolesTitle')}}</el-divider>
            <el-checkbox-group v-model="form.roles" size="small" class="checkbox-grid mb-20">
              <el-checkbox :label="1" border class="m-2 ml-10" style="width:160px;" :disabled="!isAdmin">{{$t('user.adminRole')}}</el-checkbox>
              <el-checkbox :label="16" border class="m-2" style="width:160px;" :disabled="!isAdmin">{{$t('user.repRole')}}</el-checkbox>
              <el-checkbox :label="7" border class="m-2" style="width:160px;" :disabled="!isAdmin">{{$t('user.Manager')}}</el-checkbox>
              <el-checkbox :label="19" border class="m-2" style="width:160px;" :disabled="!isAdmin">{{$t('user.CMSAdmin')}}</el-checkbox>
              <el-checkbox :label="10" border class="m-2" style="width:160px;" :disabled="!isAdmin">{{$t('user.CMSAuthor')}}</el-checkbox>
            </el-checkbox-group>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="Gestion commission" name="commission" v-if="isCurrentUserAdmin">
          <el-form :model="form" label-position="top" ref="userForm">
            <el-row :gutter="20">
              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <el-form-item :label="$t('user.commissionActivation')" :label-width="formLabelWidth">
                  <el-checkbox v-model="form.comActive">Activer</el-checkbox>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <el-form-item :label="$t('user.commission')" :label-width="formLabelWidth">
                <el-input-number v-model="form.com" type="number" placeholder="Pourcentage de commission" autocomplete="off"></el-input-number> <span class="ml-10">%</span>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-tab-pane>
      </el-tabs>
    <span slot="footer" class="dialog-footer">
      <el-button @click="close()">{{$t('common.Cancel')}}</el-button>

      <el-button v-if="currentUser!=null" type="primary" @click="editUser()">{{$t('buttons.modify')}}</el-button>
      <el-button v-else type="primary" @click="addUser()">{{$t('buttons.addNewItem')}}</el-button>
    </span>
  </div>
</el-drawer>
</template>

<script>

import userService from '@/services/API/user'
import { mapActions, mapState, mapGetters } from 'vuex';

export default{
  props: {
		userFormvisible : Boolean,
    currentUser : Object,
    type: {
      type: String,
      default: 'ADMIN'
    },
    defaultTitle: {
      type: String,
      default: null
    }
	},
  data() {
    var validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('Veuillez saisir un mot de passe'));
        } else {
          if (this.form.confirm !== '') {
            this.$refs.userForm.validateField('confirm');
          }
          callback();
        }
      };
      var validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('Veuillez confirmer votre mot de passe'));
        } else if (value !== this.form.password) {
          callback(new Error('Les mots de passe ne concordent pas!'));
        } else {
          callback();
        }
      };
    return {
      form : {
        id: null,
        active : true,
        webAccess: true,
        firstName: null,
        lastName: null,
        email: null,
        phone: null,
        roles: [],
        password : null,
        confirm: null,
        comActive: false,
        com: null,
        
      },
      activeTab: 'info',
        formLabelWidth: '120px',
        rules : {
  	  		firstName : [
  	  			{ required: true, message: 'Veuillez saisir un prénom', trigger: 'blur' }
    			],
  	  		lastName : [
  	  			{ required: true, message: 'Veuillez saisir un nom', trigger: 'blur' }
  	  		],
  	  		email : [
  	  			{ required: true, message: 'Veuillez saisir un courriel', trigger: 'blur' },
  	  			{ type: 'email', message: "Format de l'adresse courriel incorrect", trigger: ['blur', 'change'] }
  	  		],
          password: [
            { validator: validatePass, trigger: 'blur' }
          ],
          confirm: [
            { validator: validatePass2, trigger: 'blur' }
          ]
  	  	}
    }
  },
  computed : {
    drawerWidth() {
          if (this.isMobile === true) return "100%";
          else return "50%";
          
        },
    isMobile() {
            if( screen.width <= 760 ) {
                return true;
            }
            else {
                return false;
            }
        },
    isAdmin() {
      return this.type === 'ADMIN';
    },
    title() {
      if (this.defaultTitle != null) return this.defaultTitle;
      if (this.currentUser == null) {
        return this.$i18n.t('user.addUserTitle');
      }
      return this.$i18n.t('user.editUserTitle');
    },
    ...mapGetters(['isCurrentUserAdmin'])
  },
  methods : {
    close(){
      this.$refs.userForm.resetFields();
      this.form.id = null;
      this.form.roles = [];
      this.form.active = true;
      this.form.webAccess = true;
      this.form.firstName = null;
      this.form.lastName = null;
      this.form.email = null;
      this.form.password = null;
      this.form.confirm = null;
      this.form.comActive = false;
      this.form.com = null;
      this.activeTab = 'info';
      this.$emit('close');
    },
    addUser(){
      this.$refs['userForm'].validate((valid)=>{
        if(valid){
          const user = this.form;
          const roles = [];
          _.forEach(user.roles, role => {
            roles.push({id: role });
          })
          user.roles = roles;
          userService.createUser(user)
            .then(user=>{
                this.$emit('userCreated', user);
                this.close();
            })
        }
      });
    },
    editUser(){
      this.$refs['userForm'].validate((valid)=>{
        if(valid || !valid){
          const user = _.cloneDeep(this.form);
          const roles = [];
          _.forEach(user.roles, role => {
            roles.push({id: role });
          })
          user.roles = roles;
          if (user.com != null) {
            user.com = user.com / 100; // Convertir le pourcentage en valeur décimale
          } else {
            user.com = 0; // Assurez-vous que com est défini à 0 si non spécifié
          }
          userService.updateUserV2(user.id, user)
            .then(response=>{
                this.$emit('userModified', response);
                this.close();
            })
        }
      });
    },
    open(){
      if(this.currentUser!=null){
        this.form = _.cloneDeep(this.currentUser);
        if (this.form.com != null) {
          this.form.com  = this.form.com * 100; // Convertir la commission en pourcentage
        }
        const roles = _.map(_.get(this.form, 'roles'), role => (role.id));
        this.form.roles = roles;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/_variables';

.checkbox-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr); /* 2 colonnes */
  gap: 10px; /* espace entre les cases */
}


</style>
